import(/* webpackMode: "eager" */ "C:\\xampp\\htdocs\\enthioshub\\enthioshub\\frontend\\src\\app\\articles\\page.tsx");
